import { Component, OnInit } from '@angular/core';
import { faChartPie, faPlus, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/core/services/configuration/configuration.service';
import { columnHeader } from 'app/shared/factoring-datatable/factoring-datatable.component';
import { ConfirmModalComponent } from 'app/shared/utils/confirm-modal/confirm-modal.component';
import { ManageCodigoCIIUModalComponent } from '../modals/manage-codigo-ciiu-modal/manage-codigo-ciiu-modal.component';
import { functions } from '../../../core/helpers/functions';

@Component({
  selector: 'app-codigo-ciiu',
  templateUrl: './codigo-ciiu.component.html',
  styleUrls: ['./codigo-ciiu.component.css']
})
export class CodigoCIIUComponent implements OnInit {
  faChartPie = faChartPie;
  faSyncAlt  = faSyncAlt;
  faPlus     = faPlus;
  public rowData          : any[]   = [];
	public loadingTable     : boolean = false;
	public columnDefs       : columnHeader[];
	public pageTableActual  : number;
	public pageTableTotal   : number;
	public pageTablePerPages: number  = 10;
	public pageTablePages   : number[];
	public user             : any;
	public identidad        : any     = {};
	public searchstring     : string = '';
	public canCreate: boolean = false;

  constructor(
    private configurationService  : ConfigurationService,
    public modalService           : NgbModal,
  ) { }

  ngOnInit(): void {
    this.obtenerCodigosCIIU();
  }

  loadTable(data) {
    this.rowData = functions.indextable( data )
    // this.rowData           = data.results
    this.pageTableActual   = data.page_number
    this.pageTableTotal    = data.count
    this.pageTablePerPages = data.per_page
    this.pageTablePages = []
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index)
    }
  }
    
  initVars() {
    let columns = [
      {
        headerName: 'N°', 
        field     : 'index' ,
        sortable  : true,
      },
      {
        headerName: 'Código', 
        field     : 'codigo',
        class     : 'text-center',
        sortable  : true,
        filterable: true,
        filterProp: 'search',
        filterInput: true,
      },
      {
        headerName: 'Nombre', 
        field     : 'nombre',
        class     : 'text-center',
        sortable  : true,
        filterable: true,
        filterProp: 'search',
        filterInput: true,
      },
    ];
  
    this.columnDefs = columns;
  }

  obtenerCodigosCIIU(search = "", page = 1, page_size = 10) {
    let codigosCIIU = this.configurationService.obtenerCodigosCIIU(search, page, page_size);

    Promise.all([codigosCIIU]).then((res :any[])=>{
      console.log("RES", res)
      let codigosCIIU  = res[0];
      this.initVars();
      this.loadTable(codigosCIIU);
    });
  }

  crear() {
    const modalRef = this.modalService.open(ManageCodigoCIIUModalComponent, {
    });

    modalRef.result.then((result) => {
          console.log(result);
      }, (reason) => {
          console.log(reason);
    });

    modalRef.componentInstance.successEmit.subscribe(result => {
			console.log(result);
			this.obtenerCodigosCIIU();
		},
		error => {
      console.error(error);
      
		});
  }

  tableEditEvent(row) {
    const modalRef = this.modalService.open(ManageCodigoCIIUModalComponent, {
    });

    modalRef.componentInstance.codigoCIIUId = row.id;

    modalRef.componentInstance

    modalRef.result.then((result) => {
          console.log(result);
      }, (reason) => {
          console.log(reason);
    });

    modalRef.componentInstance.successEmit.subscribe(result => {
			console.log(result);
			this.obtenerCodigosCIIU();
		},
		error => {

		});
  }

  destroy(row) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
		
		});

		modalRef.componentInstance.title = 'Remover Código CIIU';
		modalRef.componentInstance.message = '¿Seguro que desea remover el Código CIIU?';
		
		modalRef.result.then((result) => {
		if (result) {
			this.configurationService.eliminarCodigoCIIU(row.id)
			.then(result => {
			this.obtenerCodigosCIIU();
			})
			.catch(error => {
			console.error(error);
			});
		}
		}, (reason) => {
			console.log(reason);
		});
  }

  goToPage({page,per_page,filtros}) {
    this.obtenerCodigosCIIU(filtros.search, page, per_page);
  }
 
}
